<template>
    <div class="base-dialog">
        <div class="flex content">
            <!-- 标题插槽 -->
            <slot name="title">
                <p class="base-dialog-title">{{ title }}</p>
            </slot>

            <!-- 内容插槽 -->
            <slot name="content">
                <p class="base-dialog-content">{{ content }}</p>
            </slot>

            <!-- 按钮插槽 -->
            <slot name="button">
                <div class="common-button base-dialog-button" @click.self="handle_submit">{{ button || '知道了' }}</div>
            </slot>
        </div>

        <div class="meng-layer" @click="handle_close"></div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
        },
        content: {
            type: String,
        },
        button: {
            type: String,
        },
    },
    data() {
        return {

        };
    },
    methods: {
        handle_close() {
            this.$emit('close');
        },
        handle_submit() {
            this.$emit('submit');
        },
    }
};
</script>
<style lang="less" scoped>
@import './baseDialog.less';
</style>
